import React from 'react';
// import {useHistory} from 'react-router-dom';

import { Table, Column, HeaderCell, Cell, ColumnGroup} from 'rsuite-table';
import 'rsuite-table/dist/css/rsuite-table.css';

const baseTableProps = {
    height: 400,
};

const baseStyles = {
    zIndex: 0,
}

export const SongGrid = ({dataSource, onRowClick}) => {
    return (
     <Table data={dataSource} {...baseTableProps} style={baseStyles} onRowClick={onRowClick}>
            <Column width={250} fixed sortable resizable>
                <HeaderCell>Track Title</HeaderCell>
                <Cell>{rowData => rowData.title}</Cell>
            </Column>
            <Column width={250} fixed sortable resizable>
                <HeaderCell>Track Duration</HeaderCell>
                <Cell>{rowData => rowData.duration}</Cell>
            </Column>
        </Table>
    )
}